// Browser-derived parent origin detection for the embed widget.
//
// Both window.location.ancestorOrigins and document.referrer are populated
// by the browser based on how the iframe was actually loaded. Page JavaScript
// (parent or child) cannot mutate either, so the value cannot be spoofed by
// crafting an iframe src like ?parentUrl=https://customer.com.

export function detectParentInfo() {
  if (typeof window === 'undefined' || window.self === window.top) {
    return { origin: '', url: '' };
  }

  const result = { origin: '', url: '' };

  if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
    result.origin = window.location.ancestorOrigins[0] || '';
  }

  if (typeof document !== 'undefined' && document.referrer) {
    try {
      const u = new URL(document.referrer);
      result.url = document.referrer;
      if (!result.origin) {
        result.origin = u.origin;
      }
    } catch (e) {
      // ignore malformed referrer
    }
  }

  return result;
}
